import styled from "styled-components";

export const PhoneInputStyle = styled.div`
  select.PhoneInputCountrySelect {
    pointer-events: none;
  }
`;
